// OBSOLETE: CPR was replaced by FCR for invoices dated on or after 2026-11-30. Remove this page anytime after 2027-01-01.
import * as React from 'react';
import { Dispatch, connect } from 'react-redux';
import { AppActionCreators, IApplicationState, ReportActionCreators, ICprScoreAuditResponse } from '@nkr/store/index';
import { ListGroupItem, OverlayTrigger } from 'react-bootstrap';
import { CompatiblePairRatioOverlay } from '@nkr/views/center-admin/action-center/center-performance/relative-performance-overlays';
import Grid from '../fcr-score-audit/grid';
import Header from '../fcr-score-audit/header';
import { Help } from '../fcr-score-audit/help';
import { useScoreAudit } from '../fcr-score-audit/use-score-audit';

interface IProps {
    centerId: number,
    isAdmin: boolean
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getCprAuditScores: (centerId: number, startDate: string, endDate: string) => Promise<ICprScoreAuditResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

const CprScoreAuditReport = (props: TProps) => {
    const getScoreAudit = (startDate: string, endDate: string) => props.getCprAuditScores(props.centerId, startDate, endDate);

    const audit = useScoreAudit({
        centerId: props.centerId,
        reportPath: 'cpr-score-audit-report',
        endDateParam: 'endDate',
        allowCustomRange: true,
        loadingMessage: 'Getting CPR Scores, one moment please...',
        showLoading: props.showLoading,
        hideLoading: props.hideLoading,
        getScoreAudit
    });

    const { state } = audit;
    const centerAlias = state.center != null ? state.center.alias : '';
    const summaryCompatible = state.data.filter(x => x.isCompatiblePair && x.isIncluded).length;
    const cprScore = Math.floor(audit.summaryIncluded > 0 ? (summaryCompatible / audit.summaryIncluded) * 100 : 0);

    return (
        <>
            {props.isAdmin && (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                    <div style={{ fontSize: 28, fontWeight: 500 }}>{centerAlias} Center CPR Audit</div>
                    <a href={'/report/cpr-report'}>Return to CPR Score Report</a>
                </div>
            )}

            <Header
                reportStart={state.newReportStart}
                reportEnd={state.newReportEnd}
                customRange={state.customRange}
                included={state.included}
                favorable={state.favorable}
                compatible={state.compatible}
                transplanted={state.transplanted}
                onReportStartChange={audit.handleReportStartChange}
                onReportEndChange={audit.handleReportEndChange}
                onReportRangeUpdate={audit.handleRefresh}
                onFilterToggle={audit.handleFilterToggle}
            >
                <tr>
                    <td># Compatible: <a style={{ cursor: 'pointer', fontWeight: 700 }} onClick={() => audit.handlePairTotalClick(false)}>{summaryCompatible}</a></td>
                    <td># Included: <a style={{ cursor: 'pointer', fontWeight: 700 }} onClick={audit.handleIncludedTotalClick}>{audit.summaryIncluded}</a></td>
                    <td>
                        <OverlayTrigger trigger={['hover', 'hover']} placement='left' overlay={<CompatiblePairRatioOverlay />}>
                            <div style={{ cursor: 'pointer' }}>
                                CPR Result: <strong>{cprScore.toString()}</strong>
                            </div>
                        </OverlayTrigger>
                    </td>
                    <td>Transplants in Report Range: <strong>{state.data.length}</strong></td>
                </tr>
            </Header>

            <Help expanded={state.expandHelp} onToggle={audit.handleToggleHelp}>
                <ListGroupItem>
                    <div style={{ fontWeight: 550 }}>Compatible Pair Ratio (CPR)</div>
                    <div style={{ paddingLeft: 20 }}>Calculated as a 6-month moving average.</div>
                </ListGroupItem>
                <ListGroupItem>
                    <div style={{ fontWeight: 550 }}>Formula for CPR Result</div>
                    <div style={{ paddingLeft: 20, width: 'fit-content' }}>
                        <div style={{ borderBottom: '1px solid black' }}>Compatible, Paired & Voucher Transplants</div>
                        <div style={{ textAlign: 'center' }}>Included Transplants</div>
                    </div>
                </ListGroupItem>
            </Help>

            <Grid
                data={audit.data}
                isAdmin={props.isAdmin}
                favorableCount={audit.favorableCount}
                compatibleCount={audit.compatibleCount}
                includedCount={audit.includedCount}
                transplantedCount={audit.transplantedCount}
            />
        </>
    );
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getCprAuditScores: (centerId, startDate, endDate) => {
            return dispatch(ReportActionCreators.getCprScoreAudit(centerId, startDate, endDate));
        }
    };
}

export const CprScoreAudit = connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(CprScoreAuditReport);
